import {debounceTime, EMPTY, fromEvent, Observable} from "rxjs"
import {useEffect, useState} from "react"
import {UseActivityProps} from "../../types/types"

export const useKeyPressTracker = ({debounceWithin}: UseActivityProps): Observable<Event> => {
    const [observable$, setObservable] = useState<Observable<Event>>(EMPTY)

    useEffect(() => {
        setObservable(
            fromEvent(document, 'keyup')
                .pipe(
                    debounceTime(debounceWithin)
                )
        )
    }, [])

    return observable$
}
